<template>
<h1 class="text-center">ScrambleTextPlugin</h1>
</template>

<script>
export default {
  name: "ScrambleTextPlugin"
}
</script>

<style scoped>

</style>